export default __webpack_public_path__ + "static/media/easy-to-clean.1bdd0400.svg";